exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tree[data-v-8aada41a]{text-align:center;overflow-x:auto;overflow-y:hidden;box-sizing:border-box}.subtree[data-v-8aada41a]{border-top:1px dashed #777;margin-top:15px;padding-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8aada41a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TechTreeView.vue
// module id = 122
// module chunks = 0